import React, { useEffect, useState } from "react";
import "./color-slider.scss";
import ReactSlider from "react-slider";
import { Row, Col } from "antd";
import { getAverageRGB } from "../../getColor";
import { colors } from "react-select/src/theme";
import axios from "axios";
const simpleColorConverter = require("simple-color-converter");
interface TLabelProps {
  label: string;
  index: number;
  isCurrent: boolean;
}
const Label = ({ label, index, isCurrent }: TLabelProps) => (
  <>
    <div
      className={isCurrent ? "label-text current" : "label-text"}
      key={index}
    >
      {label}
    </div>
  </>
);
export type IColorSliderProps = {
  returColorValue: (v: any) => void;
  color_img: any;
  fabricImage: any;
  handleColorImg: (x: any) => void;
};

const ColorSlider: React.FC<IColorSliderProps> = ({
  returColorValue,
  color_img,
  handleColorImg,
  fabricImage,
}) => {
  const [currentValue, setCurrentValue] = React.useState(100);
  const [color, setColor] = React.useState("2166c");
  const [imageTissu, setimageTissu] = React.useState(
    fabricImage[0] && fabricImage[0].images[2]?.image
  );

  const [colorObject, setColorObject] = React.useState({ r: 0, b: 0, g: 0 });
  const fabricImageRefElement = document.getElementById("image-id-fabric-hj");
  const [items, setIteams] = useState([]);
  console.log(color_img);

  /*React.useEffect(() => {
    if (fabricImageRefElement) {
   //   const color = getAverageRGB(fabricImageRefElement);
    //  setColor(`rgba(${color.r},${color.g},${color.b},${currentValue / 100})`);
     // setColorObject({
     //   r: color.r,
     //   g: color.g,
     //   b: color.b,
    //  });
   
    }
  }, [fabricImageRefElement]);*/

  const getIsCurrent = (index: number, currentValue: number) => {
    switch (index) {
      case 0:
        return currentValue < 10;
      case 1:
        return currentValue > 40 && currentValue < 60;
      case 2:
        return currentValue > 190;
      default:
        return false;
    }
  };

  const handleValueChange = React.useCallback((value: any) => {
    setCurrentValue(value);
    returColorValue(value);
  }, []);
  /* 
  React.useEffect(() => {
    if (currentValue === 0) {
      setColor("642c");
    } else if (currentValue === 10) {
      setColor("4155c");
    } else if (currentValue === 20) {
      setColor("2106c");
    } else if (currentValue === 30) {
      setColor("7543c");
    } else if (currentValue === 40) {
      setColor("2163c");
    } else if (currentValue === 50) {
      setColor("2166c");
    } else if (currentValue === 60) {
      setColor("2374c");
    } else if (currentValue === 70) {
      setColor("4143c");
    } else if (currentValue === 80) {
      setColor("2378c");
    } else if (currentValue === 90) {
      setColor("4145c");
    } else if (currentValue === 100) {
      setColor("432c");
    }
    handleColorImg(color);
  }, [currentValue, color]); */

  React.useEffect(() => {
    if (currentValue === 0) {
      setColor("100% Lighter");
    } else if (currentValue === 5) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[0]?.image);
      setColor("95% Lighter");
    } else if (currentValue === 10) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[0]?.image);
      setColor("90% Lighter");
    } else if (currentValue === 15) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[0]?.image);
      setColor("85% Lighter");
    } else if (currentValue === 20) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[0]?.image);
      setColor("80% Lighter");
    } else if (currentValue === 25) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[0]?.image);
      setColor("75% Lighter");
    } else if (currentValue === 30) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[0]?.image);
      setColor("70% Lighter");
    } else if (currentValue === 35) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[0]?.image);
      setColor("65% Lighter");
    } else if (currentValue === 40) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[0]?.image);
      setColor("60% Lighter");
    } else if (currentValue === 45) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[0]?.image);
      setColor("55% Lighter");
    } else if (currentValue === 50) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[0]?.image);
      setColor("50% Lighter");
    } else if (currentValue === 55) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[1]?.image);
      setColor("45% Lighter");
    } else if (currentValue === 60) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[1]?.image);
      setColor("40% Lighter");
    } else if (currentValue === 65) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[1]?.image);
      setColor("35% Lighter");
    } else if (currentValue === 70) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[1]?.image);
      setColor("30% Lighter");
    } else if (currentValue === 75) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[1]?.image);
      setColor("25% Lighter");
    } else if (currentValue === 80) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[1]?.image);
      setColor("20% Lighter");
    } else if (currentValue === 85) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[1]?.image);
      setColor("15% Lighter");
    } else if (currentValue === 90) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[1]?.image);
      setColor("10% Lighter");
    } else if (currentValue === 95) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[2]?.image);
      setColor("5% Lighter");
    } else if (currentValue === 100) {
      //setimageTissu(fabricImage[0].images[2].image);
      setColor("0%");
    } else if (currentValue === 105) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[2]?.image);
      setColor("5% Darker");
    } else if (currentValue === 110) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[3]?.image);
      setColor("10% Darker");
    } else if (currentValue === 115) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[3]?.image);
      setColor("15% Darker");
    } else if (currentValue === 120) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[3]?.image);
      setColor("20% Darker");
    } else if (currentValue === 125) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[3]?.image);
      setColor("25% Darker");
    } else if (currentValue === 130) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[3]?.image);
      setColor("30% Darker");
    } else if (currentValue === 135) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[3]?.image);
      setColor("35% Darker");
    } else if (currentValue === 140) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[3]?.image);
      setColor("40% Darker");
    } else if (currentValue === 145) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[3]?.image);
      setColor("45% Darker");
    } else if (currentValue === 150) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[3]?.image);
      setColor("50% Darker");
    } else if (currentValue === 155) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[4]?.image);
      setColor("55% Darker");
    } else if (currentValue === 160) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[4]?.image);
      setColor("60% Darker");
    } else if (currentValue === 165) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[4]?.image);
      setColor("65% Darker");
    } else if (currentValue === 170) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[4]?.image);
      setColor("70% Darker");
    } else if (currentValue === 175) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[4]?.image);
      setColor("75% Darker");
    } else if (currentValue === 180) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[4]?.image);
      setColor("80% Darker");
    } else if (currentValue === 185) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[4]?.image);
      setColor("85% Darker");
    } else if (currentValue === 190) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[4]?.image);
      setColor("90% Darker");
    } else if (currentValue === 195) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[4]?.image);
      setColor("95% Darker");
    } else if (currentValue === 200) {
      setimageTissu(fabricImage[0] && fabricImage[0].images[4]?.image);
      setColor("100% Darker");
    }
    handleColorImg(color);
  }, [currentValue, color]);

  return (
    <div style={{ marginTop: "50px" }}>
      {/*       <div className="slider-fabric-img" style={{ position: "relative" }}>
        <img
          // src={"/fabrics-assets/1.png"}
          src={imageTissu && process.env.REACT_APP_STORAGE_URL + imageTissu}
          style={{
            opacity: currentValue < 45 ? currentValue / 100 + 0.3 : 1,
          }}
          id={"image-id-fabric-hj"}
          alt=""
        />
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            background: "black",
            opacity: (currentValue - 100) / 200,
          }}
        />
      </div> */}
      <ReactSlider
        className="horizontal-slider-colors"
        thumbClassName="thumb"
        trackClassName="track"
        min={0}
        max={200}
        step={5}
        value={currentValue}
        onChange={(value: any) => handleValueChange(value)}
        ariaValuetext={"hellow"}
        // @ts-ignore
        ariaLabel={["Lighter", "Medium blue", "Darker"]}
        renderThumb={(props, state) => (
          <div {...props}>
            <div
              style={{
                top: "-50px",
                position: "absolute",
                margin: "-70%",
                opacity: "0.5",
              }}
            >
              {color}
            </div>
          </div>
        )}
      />
      <div className="slider-colors-labels-row">
        {/*   {["0%", color_img && color_img.name, "100%"].map((label, index) => (
          <Label
            key={index}
            isCurrent={getIsCurrent(index, currentValue)}
            label={label}
            index={index}
          />
        ))} */}
        {["100%", "0%", "100%"].map((label, index) => (
          <Label
            key={index}
            isCurrent={getIsCurrent(index, currentValue)}
            label={label}
            index={index}
          />
        ))}
      </div>
    </div>
  );
};

export { ColorSlider };

//1=642c
//2=4155c
//3=2106c
//4=7543c
//5=2163c
//6=2166c
//7=2374c
//8=4143c
//9=2378c
//10=4145c
//11=432c
/* var pantoneColor = new simpleColorConverter({
      //RGB(105, 130, 159)
      rgba: {
       // r: colorObject.r,
       // g: colorObject.g,
       // b: colorObject.b,
       r:105,
       g:130,
       b:159,
       a: currentValue / 100,
      },
      to: "pantone",
    });*/
